export default __webpack_public_path__ + "static/media/BTCY.ef4c661c.png";